<template>
    <div class="dashboard-conventions">
        <v-main>
            <div v-if="conventionLeftNumber" name="link">
                Votre offre vous permet de sélectionner encore
                <b>{{ conventionLeftNumber }}</b> conventions collectives parmi notre catalogue
            </div>
            <div v-if="canViewAllConventions && !conventionLeftNumber" name="link">
                <template v-if="this.user.selectedConventionsPopulated.length > 1">
                    Vous avez <b>{{ this.user.selectedConventionsPopulated.length }}</b> conventions
                    collectives en favoris
                </template>
                <template v-if="this.user.selectedConventionsPopulated.length == 1">
                    Vous avez <b>{{ this.user.selectedConventionsPopulated.length }}</b> convention
                    collective en favoris
                </template>
            </div>

            <dashboard-conventions-filters v-if="canViewAllConventions" v-model="filters" />
            <sep name="M" v-if="conventions && conventions.length" />
            <convention-teaser
                v-for="convention in conventions"
                mode="dashboard"
                :user="user"
                :parentConvention="convention"
                :selectedConvention="convention"
                :key="convention._uid"
            />
            <div
                class="actions"
                v-if="
                    showAll == false &&
                    this.user.selectedConventionsPopulated.length > 2 &&
                    conventions.length == 2
                "
            >
                <action @click="showAll = true" name="main">Voir toutes mes conventions</action>
            </div>
        </v-main>
    </div>
</template>

<script>
import { filter, find, slice } from "lodash";
import ConventionTeaser from "../convention/teaser/ConventionTeaser.vue";
import userMixin from "src/mixins/user";
import DashboardConventionsFilters from "./DashboardConventionsFilters.vue";

export default {
    components: { ConventionTeaser, DashboardConventionsFilters },
    props: ["user"],
    data() {
        return {
            filters: {
                query: null,
                order: null,
            },
            showAll: false,
        };
    },
    mixins: [userMixin],
    computed: {
        conventions() {
            let conventions = this.filter(this.user.selectedConventionsPopulated);
            return this.showAll ? conventions : slice(conventions, 0, 2);
        },
    },
    methods: {
        filter(conventions) {
            if (this.filters.query) {
                const query = this.clean(this.filters.query);
                return filter(conventions, c => {
                    const title = this.clean(c.title);
                    let founded = title.indexOf(query) > -1;
                    if (!founded && c.childrenConventions) {
                        founded = find(c.childrenConventions, cc => {
                            const title = this.clean(cc.title);
                            return title.indexOf(query) > -1;
                        });
                    }
                    return founded;
                });
            }
            return conventions;
        },
        clean(string) {
            if (string) {
                string = string.replace(/<\/?[^>]+(>|$)/g, "");
                string = string.replace(/(>|<)/g, "");
                string = string.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
                string = string.replace("-", "");
                return string.toLowerCase();
            }
            return "";
        },
    },
};
</script>

<style lang="sass" scoped>

.background
    background: $color-background

.convention-teaser:last-child
    margin-bottom: 0

.placeholder
    background: $color-background
    padding: $grid-gutter*2

.actions
    display: flex
    align-items: center
    justify-content: center
    margin: $grid-gutter*3 $grid-gutter 0 $grid-gutter
</style>
